module.exports = __webpack_public_path__ + "static/facebook-d87746a0b38b90525199e1d93653d7dd.png";